type SanitizeScope = (scope?: string | string[]) => string[];
export const sanitizeScope: SanitizeScope = (scope) => {
  if (!scope) return [];
  if (!Array.isArray(scope)) return scope.split(" ");
  return scope.filter(Boolean);
};
